import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter, Prompt } from 'react-router-dom'
import { FormattedMessage, FormattedHTMLMessage, FormattedDate, injectIntl, intlShape } from 'react-intl'
import { toInteger, findIndex, debounce, find, map, remove, last } from 'lodash'
import moment from 'moment'

import { callApi } from '../services/fetchService'
import { decodePatient } from '../services/encodingService'
import { openPatientRecord, openConsultation, closeConsultation } from '../actions'

import FaIcon from '../components/FaIcon'
import AutoSaveButton from '../components/AutoSaveButton'
import { Spin, Tabs, Form, Card, Button, Input, Row, Col, Popconfirm, message } from 'antd'
const FormItem = Form.Item
const { TabPane } = Tabs
const { TextArea } = Input;



/**
 * Simple observations
 */

class _SimpleObservations extends Component {

    static propTypes = {
        consultation: PropTypes.object.isRequired,
        onFieldChange: PropTypes.func.isRequired,
        intl: intlShape.isRequired
    }

    render() {
        const { consultation } = this.props
        const { getFieldDecorator } = this.props.form
        return (
            <Form>
                <FormItem label={<span><FaIcon icon="check" style={{ marginRight: '10px' }} /><FormattedMessage id="patient.observations.reasonConsultation" /></span>}>
                    {getFieldDecorator('reason', { initialValue: consultation.observations.reason })(<TextArea autosize={{ minRows: 4 }} />)}
                </FormItem>
                <FormItem label={<span><FaIcon icon="eye" style={{ marginRight: '10px' }} /><FormattedMessage id="patient.observations.observations" /></span>}>
                    {getFieldDecorator('observations', { initialValue: consultation.observations.observations })(<TextArea autosize={{ minRows: 4 }} />)}
                </FormItem>
                <FormItem label={<span><FaIcon icon="medkit" style={{ marginRight: '10px' }} /><FormattedMessage id="patient.observations.treatment" /></span>}>
                    {getFieldDecorator('treatment', { initialValue: consultation.observations.treatment })(<TextArea autosize={{ minRows: 4 }} />)}
                </FormItem>
            </Form>
        )
    }

}

const SimpleObservations = injectIntl(Form.create({
    onFieldsChange(props, changedFields) {
        props.onFieldChange(props.consultation.id, changedFields[Object.keys(changedFields)[0]])
    }
})(_SimpleObservations))



/**
 * Full observations
 */

class _FullObservations extends Component {

    static propTypes = {
        consultation: PropTypes.object.isRequired,
        onFieldChange: PropTypes.func.isRequired,
        intl: intlShape.isRequired
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const { consultation } = this.props

        return (
            <Form className="full-observations">
                <Card title={<span><FaIcon icon="info-circle" /> <FormattedMessage id="patient.observations.general" /></span>}>
                    <Row gutter={24}>
                        <Col span={12}>
                            <FormItem label={<FormattedMessage id="patient.observations.reason" />}>
                                {getFieldDecorator('reason', { initialValue: consultation.observations.reason })(<TextArea autosize={{ minRows: 4 }} />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.history" />}>
                                {getFieldDecorator('history', { initialValue: consultation.observations.history })(<TextArea autosize={{ minRows: 4 }} />)}
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem label={<FormattedMessage id="patient.observations.allergies" />}>
                                {getFieldDecorator('allergies', { initialValue: consultation.observations.allergies })(<TextArea autosize={{ minRows: 4 }} />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.currentTreatment" />}>
                                {getFieldDecorator('currentTreatment', { initialValue: consultation.observations.currentTreatment })(<TextArea autosize={{ minRows: 4 }} />)}
                            </FormItem>
                        </Col>
                    </Row>
                </Card>
                <Card title={<span><FaIcon icon="history" /> <FormattedMessage id="patient.observations.lifeline" /></span>}>
                    <Row gutter={24}>
                        <Col span={12}>
                            <FormItem label={<FormattedMessage id="patient.observations.birthWeight" />}>
                                {getFieldDecorator('birthWeight', { initialValue: consultation.observations.birthWeight })(<TextArea autosize/>)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.pregnancyComplications" />}>
                                {getFieldDecorator('pregnancyComplications', { initialValue: consultation.observations.pregnancyComplications })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.childBirth" />}>
                                {getFieldDecorator('childBirth', { initialValue: consultation.observations.childBirth })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.childFeeding" />}>
                                {getFieldDecorator('childFeeding', { initialValue: consultation.observations.childFeeding })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.vaccinations" />}>
                                {getFieldDecorator('vaccinations', { initialValue: consultation.observations.vaccinations })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.childhoodDiseases" />}>
                                {getFieldDecorator('childhoodDiseases', { initialValue: consultation.observations.childhoodDiseases })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.childhoodTrauma" />}>
                                {getFieldDecorator('childhoodTrauma', { initialValue: consultation.observations.childhoodTrauma })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.pubertyAge" />}>
                                {getFieldDecorator('pubertyAge', { initialValue: consultation.observations.pubertyAge })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.pubertyMenstruation" />}>
                                {getFieldDecorator('pubertyMenstruation', { initialValue: consultation.observations.pubertyMenstruation })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.menstruation" />}>
                                {getFieldDecorator('menstruation', { initialValue: consultation.observations.menstruation })(<TextArea autosize />)}
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem label={<FormattedMessage id="patient.observations.acne" />}>
                                {getFieldDecorator('acne', { initialValue: consultation.observations.acne })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.herpes" />}>
                                {getFieldDecorator('herpes', { initialValue: consultation.observations.herpes })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.pills" />}>
                                {getFieldDecorator('pills', { initialValue: consultation.observations.pills })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.wedding" />}>
                                {getFieldDecorator('wedding', { initialValue: consultation.observations.wedding })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.pregnancies" />}>
                                {getFieldDecorator('pregnancies', { initialValue: consultation.observations.pregnancies })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.complications" />}>
                                {getFieldDecorator('complications', { initialValue: consultation.observations.complications })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.deliveryLabor" />}>
                                {getFieldDecorator('deliveryLabor', { initialValue: consultation.observations.deliveryLabor })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.childFeeding2" />}>
                                {getFieldDecorator('childFeeding2', { initialValue: consultation.observations.childFeeding2 })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.menopause" />}>
                                {getFieldDecorator('menopause', { initialValue: consultation.observations.menopause })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.hotFlushes" />}>
                                {getFieldDecorator('hotFlushes', { initialValue: consultation.observations.hotFlushes })(<TextArea autosize />)}
                            </FormItem>
                        </Col>
                    </Row>
                </Card>
                <Card title={<span><FaIcon icon="users" /> <FormattedMessage id="patient.observations.familyHistory" /></span>}>
                    <Row gutter={24}>
                        <Col span={12}>
                            <FormItem label={<FormattedMessage id="patient.observations.father" />}>
                                {getFieldDecorator('father', { initialValue: consultation.observations.father })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.paternalSide" />}>
                                {getFieldDecorator('paternalSide', { initialValue: consultation.observations.paternalSide })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.brotherSister" />}>
                                {getFieldDecorator('brotherSister', { initialValue: consultation.observations.brotherSister })(<TextArea autosize />)}
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem label={<FormattedMessage id="patient.observations.mother" />}>
                                {getFieldDecorator('mother', { initialValue: consultation.observations.mother })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.maternalSide" />}>
                                {getFieldDecorator('maternalSide', { initialValue: consultation.observations.maternalSide })(<TextArea autosize />)}
                            </FormItem>
                        </Col>
                    </Row>
                </Card>
                <Card title={<span><FaIcon icon="play" /> <FormattedMessage id="patient.observations.dailyLife" /></span>}>
                    <Row gutter={24}>
                        <Col span={12}>
                            <FormItem label={<FormattedMessage id="patient.observations.shy" />}>
                                {getFieldDecorator('shy', { initialValue: consultation.observations.shy })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.anguish" />}>
                                {getFieldDecorator('anguish', { initialValue: consultation.observations.anguish })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.hypersensitivity" />}>
                                {getFieldDecorator('hypersensitivity', { initialValue: consultation.observations.hypersensitivity })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.furyStrike" />}>
                                {getFieldDecorator('furyStrike', { initialValue: consultation.observations.furyStrike })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.wakeUp" />}>
                                {getFieldDecorator('wakeUp', { initialValue: consultation.observations.wakeUp })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.sleep" />}>
                                {getFieldDecorator('sleep', { initialValue: consultation.observations.sleep })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.pooh" />}>
                                {getFieldDecorator('pooh', { initialValue: consultation.observations.pooh })(<TextArea autosize />)}
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem label={<FormattedMessage id="patient.observations.nap" />}>
                                {getFieldDecorator('nap', { initialValue: consultation.observations.nap })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.effort" />}>
                                {getFieldDecorator('effort', { initialValue: consultation.observations.effort })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.snacks" />}>
                                {getFieldDecorator('snacks', { initialValue: consultation.observations.snacks })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.libido" />}>
                                {getFieldDecorator('libido', { initialValue: consultation.observations.libido })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.diseases" />}>
                                {getFieldDecorator('diseases', { initialValue: consultation.observations.diseases })(<TextArea autosize={{ minRows: 4 }} />)}
                            </FormItem>
                        </Col>
                    </Row>
                </Card>
                <Row gutter={24}>
                    <Col span={12}>
                        <Card title={<span><FaIcon icon="stethoscope" /> <FormattedMessage id="patient.observations.clinicalExam" /></span>}>
                            <FormItem label={<FormattedMessage id="patient.observations.bloodPressure" />}>
                                {getFieldDecorator('bloodPressure', { initialValue: consultation.observations.bloodPressure })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.heartBeat" />}>
                                {getFieldDecorator('heartBeat', { initialValue: consultation.observations.heartBeat })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.height" />}>
                                {getFieldDecorator('height', { initialValue: consultation.observations.height })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.weight" />}>
                                {getFieldDecorator('weight', { initialValue: consultation.observations.weight })(<TextArea autosize />)}
                            </FormItem>
                        </Card>
                        <Card title={<span><FaIcon icon="bed" /> <FormattedMessage id="patient.observations.lyingExam" /></span>}>
                            <FormItem label={<FormattedMessage id="patient.observations.hair" />}>
                                {getFieldDecorator('hair', { initialValue: consultation.observations.hair })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.eyeslashes" />}>
                                {getFieldDecorator('eyeslashes', { initialValue: consultation.observations.eyeslashes })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.eyebrows" />}>
                                {getFieldDecorator('eyebrows', { initialValue: consultation.observations.eyebrows })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.pupils" />}>
                                {getFieldDecorator('pupils', { initialValue: consultation.observations.pupils })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.skinTexture" />}>
                                {getFieldDecorator('skinTexture', { initialValue: consultation.observations.skinTexture })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.ears" />}>
                                {getFieldDecorator('ears', { initialValue: consultation.observations.ears })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.reflexes" />}>
                                {getFieldDecorator('reflexes', { initialValue: consultation.observations.reflexes })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.chvostek" />}>
                                {getFieldDecorator('chvostek', { initialValue: consultation.observations.chvostek })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.dentition" />}>
                                {getFieldDecorator('dentition', { initialValue: consultation.observations.dentition })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.tongue" />}>
                                {getFieldDecorator('tongue', { initialValue: consultation.observations.tongue })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.salivaryGlands" />}>
                                {getFieldDecorator('salivaryGlands', { initialValue: consultation.observations.salivaryGlands })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.neck" />}>
                                {getFieldDecorator('neck', { initialValue: consultation.observations.neck })(<TextArea autosize />)}
                            </FormItem>
                        </Card>
                        <Card title={<span><FaIcon icon="user-alt" /> <FormattedMessage id="patient.observations.abdomen" /></span>}>
                            <FormItem label={<FormattedMessage id="patient.observations.auscultation" />}>
                                {getFieldDecorator('auscultation', { initialValue: consultation.observations.auscultation })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.palpation" />}>
                                {getFieldDecorator('palpation', { initialValue: consultation.observations.palpation })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.urine" />}>
                                {getFieldDecorator('urine', { initialValue: consultation.observations.urine })(<TextArea autosize />)}
                            </FormItem>
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card title={<span><FaIcon icon="child" /> <FormattedMessage id="patient.observations.upperMembers" /></span>}>
                            <FormItem label={<FormattedMessage id="patient.observations.cellulitis" />}>
                                {getFieldDecorator('cellulitis', { initialValue: consultation.observations.cellulitis })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.axillaryHollow" />}>
                                {getFieldDecorator('axillaryHollow', { initialValue: consultation.observations.axillaryHollow })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.fur" />}>
                                {getFieldDecorator('fur', { initialValue: consultation.observations.fur })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.handTemperature" />}>
                                {getFieldDecorator('handTemperature', { initialValue: consultation.observations.handTemperature })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.sweat" />}>
                                {getFieldDecorator('sweat', { initialValue: consultation.observations.sweat })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.skinTexture2" />}>
                                {getFieldDecorator('skinTexture2', { initialValue: consultation.observations.skinTexture2 })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.reflexes2" />}>
                                {getFieldDecorator('reflexes2', { initialValue: consultation.observations.reflexes2 })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.nails" />}>
                                {getFieldDecorator('nails', { initialValue: consultation.observations.nails })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.fingers" />}>
                                {getFieldDecorator('fingers', { initialValue: consultation.observations.fingers })(<TextArea autosize />)}
                            </FormItem>
                        </Card>
                        <Card title={<span><FaIcon icon="male" /> <FormattedMessage id="patient.observations.posture" /></span>}>
                            <FormItem label={<FormattedMessage id="patient.observations.description" />}>
                                {getFieldDecorator('description', { initialValue: consultation.observations.description })(<TextArea autosize={{ minRows: 4 }} />)}
                            </FormItem>
                        </Card>
                        <Card title={<span><FaIcon icon="heartbeat" /> <FormattedMessage id="patient.observations.thorax" /></span>}>
                            <FormItem label={<FormattedMessage id="patient.observations.inspection" />}>
                                {getFieldDecorator('inspection', { initialValue: consultation.observations.inspection })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.cardiacAusc" />}>
                                {getFieldDecorator('cardiacAusc', { initialValue: consultation.observations.cardiacAusc })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.pulmonaryAusc" />}>
                                {getFieldDecorator('pulmonaryAusc', { initialValue: consultation.observations.pulmonaryAusc })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.breast" />}>
                                {getFieldDecorator('breast', { initialValue: consultation.observations.breast })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.dermographisme" />}>
                                {getFieldDecorator('dermographisme', { initialValue: consultation.observations.dermographisme })(<TextArea autosize />)}
                            </FormItem>
                        </Card>
                    </Col>
                </Row>
                <Card title={<span><FormattedMessage id="patient.observations.legs" /></span>}>
                    <Row gutter={24}>
                        <Col span={12}>
                            <FormItem label={<FormattedMessage id="patient.observations.cellulitis2" />}>
                                {getFieldDecorator('cellulitis2', { initialValue: consultation.observations.cellulitis2 })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.stretchMarks" />}>
                                {getFieldDecorator('stretchMarks', { initialValue: consultation.observations.stretchMarks })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.reflexes3" />}>
                                {getFieldDecorator('reflexes3', { initialValue: consultation.observations.reflexes3 })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.thighs" />}>
                                {getFieldDecorator('thighs', { initialValue: consultation.observations.thighs })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.fur2" />}>
                                {getFieldDecorator('fur2', { initialValue: consultation.observations.fur2 })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.kneeTemperature" />}>
                                {getFieldDecorator('kneeTemperature', { initialValue: consultation.observations.kneeTemperature })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.footTemperature" />}>
                                {getFieldDecorator('footTemperature', { initialValue: consultation.observations.footTemperature })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.skin" />}>
                                {getFieldDecorator('skin', { initialValue: consultation.observations.skin })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.sweating" />}>
                                {getFieldDecorator('sweating', { initialValue: consultation.observations.sweating })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.nails2" />}>
                                {getFieldDecorator('nails2', { initialValue: consultation.observations.nails2 })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.plantOfFeet" />}>
                                {getFieldDecorator('plantOfFeet', { initialValue: consultation.observations.plantOfFeet })(<TextArea autosize />)}
                            </FormItem>

                        </Col>
                        <Col span={12}>
                            <FormItem label={<FormattedMessage id="patient.observations.back" />}>
                                {getFieldDecorator('back', { initialValue: consultation.observations.back })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.shoulderBlades" />}>
                                {getFieldDecorator('shoulderBlades', { initialValue: consultation.observations.shoulderBlades })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.bisonBump" />}>
                                {getFieldDecorator('bisonBump', { initialValue: consultation.observations.bisonBump })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.cellulitis3" />}>
                                {getFieldDecorator('cellulitis3', { initialValue: consultation.observations.cellulitis3 })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.liver" />}>
                                {getFieldDecorator('liver', { initialValue: consultation.observations.liver })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.spleen" />}>
                                {getFieldDecorator('spleen', { initialValue: consultation.observations.spleen })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.adrenalGlands" />}>
                                {getFieldDecorator('adrenalGlands', { initialValue: consultation.observations.adrenalGlands })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.thighs2" />}>
                                {getFieldDecorator('thighs2', { initialValue: consultation.observations.thighs2 })(<TextArea autosize />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="patient.observations.thighs3" />}>
                                {getFieldDecorator('thighs3', { initialValue: consultation.observations.thighs3 })(<TextArea autosize />)}
                            </FormItem>
                        </Col>
                    </Row>
                </Card>
                <Row gutter={24}>
                    <Col span={12}>
                        <Card title={<span><FaIcon icon="leaf" /> <FormattedMessage id="patient.observations.biology" /></span>}>
                            <FormItem>
                                {getFieldDecorator('biology', { initialValue: consultation.observations.biology })(<TextArea autosize={{ minRows: 4 }} />)}
                            </FormItem>
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card title={<span><FaIcon icon="pills" /> <FormattedMessage id="patient.observations.treatment" /></span>}>
                            <FormItem>
                                {getFieldDecorator('treatment', { initialValue: consultation.observations.treatment })(<TextArea autosize={{ minRows: 4 }} />)}
                            </FormItem>
                        </Card>
                    </Col>
                </Row>
            </Form>
        )
    }

}

const FullObservations = injectIntl(Form.create({
    onFieldsChange(props, changedFields) {
        props.onFieldChange(props.consultation.id, changedFields[Object.keys(changedFields)[0]])
    }
})(_FullObservations))



/**
 * Observations view
 */

class PatientObservations extends Component {

    static propTypes = {
        openPatientRecord: PropTypes.func.isRequired,
        openConsultation: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        consultation: PropTypes.object,
        intl: intlShape.isRequired,
        session: PropTypes.object.isRequired
    }
    
    state = {
        patientId: null,
        patient: {},
        consultations: null,
        loading: false,
        activeTab: null,
        dirty: {}
    }

    fetch = () => {
        const { intl, openPatientRecord } = this.props
        this.setState({ loading: true })
        callApi([{
            endpoint: 'patients/' + this.state.patientId
        }, {
            endpoint: 'patients/' + this.state.patientId + '/consultations'
        }]).then((data) => {
            decodePatient(data[0]).then((decoded) => {
                data[0] = decoded
                this.setState({
                    patient: data[0],
                    consultations: data[1],
                    loading: false
                })
                openPatientRecord(data[0])
            })
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentWillReceiveProps(nextProps) {
        let id = toInteger(nextProps.match.params.id)
        if (this.state.patientId !== id) {
            this.setState({ patientId: id }, () => {
                this.fetch()
            })
        }
    }

    componentWillMount() {
        let id = toInteger(this.props.match.params.id)
        this.setState({ patientId: id })
    }

    componentDidMount() {
        this.fetch()
    }

    saveConsultation = (id) => {
        const { intl } = this.props
        const { consultations, dirty } = this.state
        const consultation = consultations[findIndex(consultations, { id })]
        callApi({
            endpoint: 'consultations/' + consultation.id,
            body: consultation,
            method: 'POST'
        }).catch((err) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
        })
        dirty[id] = false
        this.setState({ dirty })
    }

    addConsultation = () => {
        const { intl, openConsultation } = this.props
        const { consultations } = this.state
        if (this.canAddConsultation()) {
            callApi({
                endpoint: 'consultations',
                body: {
                    patient: this.state.patientId,
                    date: Date.now()
                },
                method: 'PUT'
            }).then((data) => {
                consultations.push(data)
                this.setState({
                    consultations: consultations,
                    activeTab: "" + data.id
                })
                openConsultation(data)
                message.success(intl.formatMessage({id: "misc.updateSuccess"}))
            }).catch((err) => {
                message.error(intl.formatMessage({id: 'misc.unknownError'}))
            })
        }
    }

    deleteConsultation = () => {
        const { intl, consultation, openConsultation, closeConsultation } = this.props
        const { consultations, activeTab } = this.state
        const currentConsultationId = activeTab || (consultation ? "" + consultation.id : (consultations.length ? "" + consultations[consultations.length - 1].id : null))
        callApi({
            endpoint: 'consultations/' + currentConsultationId,
            method: 'DELETE'
        }).then((data) => {
            remove(consultations, { id: data.id })
            let lastConsultation = last(consultations)
            this.setState({
                consultations: consultations,
                activeTab: "" + (lastConsultation ? lastConsultation.id : null)
            })
            if (lastConsultation) {
                openConsultation(lastConsultation)
            } else {
                closeConsultation()
            }
            message.success(intl.formatMessage({id: "misc.deleteSuccess"}))
        }).catch((err) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
        })
    }

    canAddConsultation = () => {
        const { consultations } = this.state
        if (consultations.length) {
            const lastDate = consultations[consultations.length-1].date
            return !moment(lastDate).isSame(moment(), 'day')
        }
        return true
    }

    debouncedFunctions = {}
    onFieldChange = (id, changedField) => {
        const { consultations, dirty } = this.state
        consultations[findIndex(consultations, { id })].observations[changedField.name] = changedField.value
        this.setState({
            consultations: consultations
        })
        if (!this.debouncedFunctions[id]) {
            this.debouncedFunctions[id] = debounce(this.saveConsultation, 3 * 1000, { maxWait: 30 * 1000 })
        }
        this.debouncedFunctions[id](id)
        dirty[id] = true
        this.setState({ dirty })
    }

    forceSave = () => {
        const { dirty } = this.state
        map(dirty, (value, key) => {
            if (value === true) {
                this.saveConsultation(Number(key))
            }
        })
    }

    onTabsChange = (activeTab) => {
        this.setState({ activeTab: "" + activeTab });
    }

    render() {
        const { patient, loading, consultations, activeTab, dirty } = this.state
        const { consultation, intl } = this.props
        const { user } = this.props.session

		if (consultations === null || loading) {
			return (
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <Spin size="large" />
                </div>
            )
        }

        const isDirty = !!find(dirty, value => value === true)

        const currentConsultationId = consultation ? consultation.id : null
        const newActiveTab = activeTab || (consultation ? "" + consultation.id : (consultations.length ? "" + consultations[consultations.length - 1].id : null))

        let firstConsultation = null
        let otherConsultations = null
        if (consultations.length) {
            firstConsultation = consultations[0]
            otherConsultations = consultations.slice(1)
        }
        
        return (
            <div>
                <h1><FaIcon icon="user" fixedWidth /><FormattedHTMLMessage id="patient.observations.title" values={patient} /></h1>
                { this.canAddConsultation() ? <div className="action-bar"><Button onClick={this.addConsultation} disabled={!user.canAddConsultations}><FaIcon icon="plus" /> <FormattedMessage id="patient.misc.addConsultation" /></Button></div> : null }
                {
                    !consultations.length ? (
                        <div className="message" style={{ marginTop: "45px" }}>
                            <FaIcon icon="exclamation-circle" size="8x" />
                            <br /><br />
                            <span style={{ fontSize: "35px" }}><FormattedMessage id="patient.misc.noConsultations" /></span>
                            <br /><br />
                            <FormattedMessage id="patient.misc.noConsultations.description" />
                        </div>
                    ) : (
                        <div>
                            <Tabs onChange={this.onTabsChange} activeKey={newActiveTab} tabBarExtraContent={
                                !!consultations.length 
                                    ? <div>
                                        <Popconfirm title={<FormattedMessage id="misc.confirm" />} onConfirm={this.deleteConsultation} okText={intl.formatMessage({id: 'misc.yes'})} cancelText={intl.formatMessage({id: 'misc.no'})}>
                                            <Button><FaIcon icon="trash" /> <FormattedMessage id="patient.misc.deleteConsultation" /></Button>&nbsp;&nbsp;
                                        </Popconfirm>
                                    </div>
                                    : null
                            }>
                                <TabPane tab={firstConsultation.id === currentConsultationId 
                                        ? <strong><FaIcon icon="angle-double-right" size="lg" /> <FormattedDate value={firstConsultation.date} /></strong>
                                        : <FormattedDate value={firstConsultation.date} />
                                } key={"" + firstConsultation.id}>
                                    <FullObservations consultation={firstConsultation} onFieldChange={this.onFieldChange} />
                                </TabPane>
                                {
                                    otherConsultations.map((consultation) => (
                                        <TabPane tab={consultation.id === currentConsultationId 
                                            ? <strong><FaIcon icon="angle-double-right" size="lg" /> <FormattedDate value={consultation.date} /></strong>
                                            : <FormattedDate value={consultation.date} />
                                        } key={"" + consultation.id}>
                                            <SimpleObservations consultation={consultation} onFieldChange={this.onFieldChange} />
                                        </TabPane>
                                    ))
                                }
                            </Tabs>
                            <AutoSaveButton isDirty={isDirty} onClick={this.forceSave} />
                        </div>
                    )
                }
                <Prompt when={isDirty} message={intl.formatMessage({id: 'misc.unsavedData'})} />
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    consultation: state.consultation,
    session: state.session
})

export default injectIntl(withRouter(connect(mapStateToProps, {
    openPatientRecord,
    openConsultation,
    closeConsultation
})(PatientObservations)))


// WEBPACK FOOTER //
// ./src/views/PatientObservations.js